import { render } from "./AbsenceDetails.vue?vue&type=template&id=78361185&ts=true"
import script from "./AbsenceDetails.vue?vue&type=script&lang=ts"
export * from "./AbsenceDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/local/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__